import e from "./InfiniteHits.vue_rollup-plugin-vue=script.js";
export default (function (e, t, s, n, i, r, a, u) {
  var l = ("function" == typeof s ? s.options : s) || {};
  return l.__file = "InfiniteHits.vue", l.render || (l.render = e.render, l.staticRenderFns = e.staticRenderFns, l._compiled = !0, i && (l.functional = !0)), l._scopeId = n, l;
})({
  render: function render() {
    var e = this,
        t = e.$createElement,
        s = e._self._c || t;
    return e.state ? s("div", {
      class: e.suit()
    }, [e.showPrevious ? e._t("loadPrevious", function () {
      return [s("button", {
        class: [e.suit("loadPrevious"), e.state.isFirstPage && e.suit("loadPrevious", "disabled")],
        attrs: {
          disabled: e.state.isFirstPage
        },
        on: {
          click: function click(t) {
            return e.refinePrevious();
          }
        }
      }, [e._v("\n      Show previous results\n    ")])];
    }, {
      refinePrevious: e.refinePrevious,
      page: e.state.results.page,
      isFirstPage: e.state.isFirstPage
    }) : e._e(), e._v(" "), e._t("default", function () {
      return [e.showBanner && e.state.banner && e.state.banner.image.urls[0].url ? [e._t("banner", function () {
        return [s("aside", {
          class: e.suit("banner")
        }, [e.state.banner.link ? s("a", {
          class: e.suit("banner-link"),
          attrs: {
            href: e.state.banner.link.url,
            target: e.state.banner.link.target
          }
        }, [s("img", {
          class: e.suit("banner-image"),
          attrs: {
            src: e.state.banner.image.urls[0].url,
            alt: e.state.banner.image.title
          }
        })]) : s("img", {
          class: e.suit("banner-image"),
          attrs: {
            src: e.state.banner.image.urls[0].url,
            alt: e.state.banner.image.title
          }
        })])];
      }, {
        banner: e.state.banner
      })] : e._e(), e._v(" "), s("ol", {
        class: e.suit("list")
      }, e._l(e.state.items, function (t, n) {
        return s("li", {
          key: t.objectID,
          class: e.suit("item"),
          on: {
            click: function click(s) {
              return e.state.sendEvent("click:internal", t, "Hit Clicked");
            },
            auxclick: function auxclick(s) {
              return e.state.sendEvent("click:internal", t, "Hit Clicked");
            }
          }
        }, [e._t("item", function () {
          return [e._v("\n          objectID: " + e._s(t.objectID) + ", index: " + e._s(n) + "\n        ")];
        }, {
          item: t,
          index: n,
          insights: e.state.insights,
          sendEvent: e.state.sendEvent
        })], 2);
      }), 0), e._v(" "), e._t("loadMore", function () {
        return [s("button", {
          class: [e.suit("loadMore"), e.state.isLastPage && e.suit("loadMore", "disabled")],
          attrs: {
            disabled: e.state.isLastPage
          },
          on: {
            click: function click(t) {
              return e.refineNext();
            }
          }
        }, [e._v("\n        Show more results\n      ")])];
      }, {
        refineNext: e.refineNext,
        refine: e.refineNext,
        page: e.state.results.page,
        isLastPage: e.state.isLastPage
      })];
    }, {
      items: e.state.items,
      results: e.state.results,
      banner: e.state.banner,
      isLastPage: e.state.isLastPage,
      refinePrevious: e.refinePrevious,
      refineNext: e.refineNext,
      refine: e.refineNext,
      insights: e.state.insights,
      sendEvent: e.state.sendEvent
    })], 2) : e._e();
  },
  staticRenderFns: []
}, 0, e, void 0, !1);